<template>
  <b-form-group
    label="İçerik Başlık"
    label-for="content_title"
  >
    <validation-provider
      #default="{ errors }"
      name="İçerik Başlık"
      rules="required"
    >
      <b-form-input
        id="content_title"
        v-model="itemData.content_title"
        placeholder="İçerik Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'ContentTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
}
</script>
